import { render, staticRenderFns } from "./Form_CommonKpi.vue?vue&type=template&id=31af2d2a&scoped=true"
import script from "./Form_CommonKpi.vue?vue&type=script&lang=js"
export * from "./Form_CommonKpi.vue?vue&type=script&lang=js"
import style0 from "./Form_CommonKpi.vue?vue&type=style&index=0&id=31af2d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af2d2a",
  null
  
)

export default component.exports